import * as angular from 'angular';
import { ICampaign, ICampaignProductLink } from '../../models';
import { ngStorage } from 'ngstorage';

export class CampaignDescriptionController {

    public static $inject = ['$localStorage'];

    campaign: ICampaign = null;
    countryID: number;

    constructor(
        private $localStorage: ngStorage.StorageService
    ) { }

    $onInit() {
        this.countryID = this.$localStorage.retailerAuthorizationData.countryID;
    }

    isNotDraft(item: ICampaignProductLink) {
        return !item.isDraft;
    }
}

angular
    .module('naut')
    .component('campaignDescription', {
        template: require('./campaign-description.html'),
        controller: CampaignDescriptionController,
        bindings: {
            campaign: '<'
        }
    });



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/campaigns/components/campaignDescription/camapign-description.ts